import { useTranslation } from 'react-i18next';
import React from 'react';
import Box from '@mui/material/Box';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import SatelliteIcon from '@mui/icons-material/Satellite';

import type { MapStyle } from '../types';

export interface MapStyleSwitcherProps {
  currentStyle: MapStyle;
  onStyleChange: (style: MapStyle) => void;
}

/**
 * Floating control to switch between map styles (streets, satellite, outdoors).
 */
export const MapStyleSwitcher: React.FC<MapStyleSwitcherProps> = ({ currentStyle, onStyleChange }) => {
  const { t } = useTranslation();
  const handleChange = (_event: React.MouseEvent<HTMLElement>, newStyle: MapStyle | null) => {
    if (newStyle) {
      onStyleChange(newStyle);
    }
  };

  return (
    <Box
      sx={{
        position: 'absolute',
        bottom: 32,
        right: 12,
        zIndex: 10,
        bgcolor: 'background.paper',
        borderRadius: 1,
        boxShadow: 2,
      }}
    >
      <ToggleButtonGroup
        value={currentStyle}
        exclusive
        onChange={handleChange}
        size="small"
        aria-label="Map style"
      >
        <ToggleButton value="streets" aria-label="Street">
          <DirectionsCarIcon fontSize="small" sx={{ mr: 0.5 }} />
          {t('map.street')}
        </ToggleButton>
        <ToggleButton value="satellite" aria-label="Satellite">
          <SatelliteIcon fontSize="small" sx={{ mr: 0.5 }} />
          {t('map.satellite')}
        </ToggleButton>
        
      </ToggleButtonGroup>
    </Box>
  );
};
